/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/users-authz-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/users-authz-api-client";
import type { UsersAuthzAPIAdminPermissionsWriteDenyPermissionToUserMutationResponse, UsersAuthzAPIAdminPermissionsWriteDenyPermissionToUserPathParams } from "../models/UsersAuthzAPIAdminPermissionsWriteDenyPermissionToUser";
import type { UseMutationOptions, QueryClient } from "@tanstack/react-query";
import { usersAuthzAPIAdminPermissionsWriteDenyPermissionToUser } from "../axios/usersAuthzAPIAdminPermissionsWriteDenyPermissionToUser";
import { useMutation } from "@tanstack/react-query";

export const usersAuthzAPIAdminPermissionsWriteDenyPermissionToUserMutationKey = () => ["users-authz-api", { url: '/admin/user/:userId/permissions/:permission/deny' }] as const

export type UsersAuthzAPIAdminPermissionsWriteDenyPermissionToUserMutationKey = ReturnType<typeof usersAuthzAPIAdminPermissionsWriteDenyPermissionToUserMutationKey>

/**
 * @summary Deny a permission for a user
 * {@link /admin/user/:userId/permissions/:permission/deny}
 */
export function useUsersAuthzAPIAdminPermissionsWriteDenyPermissionToUser<TContext>(options: 
{
  mutation?: UseMutationOptions<UsersAuthzAPIAdminPermissionsWriteDenyPermissionToUserMutationResponse, ResponseErrorConfig<Error>, {userId: UsersAuthzAPIAdminPermissionsWriteDenyPermissionToUserPathParams["userId"], permission: UsersAuthzAPIAdminPermissionsWriteDenyPermissionToUserPathParams["permission"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: typeof fetch },
}
 = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? usersAuthzAPIAdminPermissionsWriteDenyPermissionToUserMutationKey()

  return useMutation<UsersAuthzAPIAdminPermissionsWriteDenyPermissionToUserMutationResponse, ResponseErrorConfig<Error>, {userId: UsersAuthzAPIAdminPermissionsWriteDenyPermissionToUserPathParams["userId"], permission: UsersAuthzAPIAdminPermissionsWriteDenyPermissionToUserPathParams["permission"]}, TContext>({
    mutationFn: async({ userId, permission }) => {
      return usersAuthzAPIAdminPermissionsWriteDenyPermissionToUser(userId, permission, config)
    },
    mutationKey,
    ...mutationOptions
  }, queryClient)
}